import React from 'react';
import { Grid, Row, Col, Button, Panel } from 'react-bootstrap';

import * as fetchingState from '../../constants/fetchingState';
import Pagination from 'react-js-pagination';

let Entities = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activePage: 1,
            isNew: null,
            editModelShown: false,
            entity: undefined
        };

        this._createClick = this._createClick.bind(this);
        this._editClick = this._editClick.bind(this);
        this._editModalClose = this._editModalClose.bind(this);
        this._renderButtons = this._renderButtons.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
        this._refreshClick = this._refreshClick.bind(this);
        this._onPageClick = this._onPageClick.bind(this);
        this._renderPagination = this._renderPagination.bind(this);
    }

    _createClick() {
        const { createEntity } = this.props;
        this.setState({
            isNew: true,
            entity: createEntity,
            editModalShown: true
        });
    }

    _editClick(entity) {
        this.setState({
            isNew: false,
            entity,
            editModalShown: true
        });
    }

    _editModalClose() {
        this.props.clearCrudAction(this.state.isNew);
        this.setState({
            editModalShown: false,
            entity: undefined,
            isNew: null
        });
        if (this.props.reloadOnModalClosing)
            this.props.loadAction();
    }

    _onSubmit(values) {
        this.state.isNew ? this.props.createAction(values) : this.props.updateAction(values);
    }

    _refreshClick() {
        this.props.loadAction();
    }

    _onPageClick(activePage) {
        this.setState({
            activePage
        })
    }

    componentWillReceiveProps({ entities: nextEntities }) {
        const entities = this.props.entities ? this.props.entities : [];
        if (!nextEntities || nextEntities.length !== entities.length) {
            this.setState({ activePage: 1 });
        }
    }

    _renderButtons() {
        const { canRefresh, canCreate, createDisabled } = this.props;
        return (
            <Row>
                <Col lg={12}>
                    {canRefresh &&
                        <Button bsStyle='success' onClick={this._refreshClick}>Обновить</Button>}
                    {canCreate &&
                        <Button bsStyle='primary' disabled={createDisabled} 
                        onClick={createDisabled ? undefined : this._createClick}>Создать</Button>}
                </Col>
            </Row>);
    }

    _renderPagination() {
        const { pagination, fetching, entities: { length } } = this.props;
        if (!pagination || fetching !== fetchingState.FETCHED || length < pagination.itemsCountPerPage)
            return null;

        const paginationProps = {
            ...pagination,
            totalItemsCount: length,
            onChange: this._onPageClick,
            activePage: this.state.activePage
        }

        return (
            <Row>
                <Col lg={12} style={{ textAlign: 'center' }}>
                    <Pagination {...paginationProps} />
                </Col>
            </Row>);
    }

    render() {
        const {
            contentTable: Table,
            editModal: EditModal,
            createModal: CreateModal,
            entities,
            fetching,
            createFetching,
            updateFetching,
            createError,
            updateError,
            header,
            pagination,
            error
        } = this.props;

        const { editModalShown, entity, isNew, activePage } = this.state;

        const tableProps = {
            editClick: this._editClick,
            entities: pagination ?
                entities.slice((activePage - 1) * pagination.itemsCountPerPage, activePage * pagination.itemsCountPerPage) :
                entities,
            fetching,
            parentProps: this.props
        };

        const editModalProps = {
            initialValues: isNew ? this.props.createEntity : entity,
            isNew,
            fetching: isNew ? createFetching : updateFetching,
            crudError: isNew ? createError : updateError,
            onSubmit: this._onSubmit,
            onClose: this._editModalClose
        };

        return (
            <Grid fluid={true}>
                {this._renderButtons()}
                <Panel>
                    <Panel.Heading>{header}</Panel.Heading>
                    <Panel.Body>
                        <Row>
                            <Col lg={12}>
                                {fetching === fetchingState.FETCHED && entities.length > 0 && <Table {...tableProps} />}
                                {isNew === false && editModalShown && <EditModal {...editModalProps} />}
                                {isNew === true && editModalShown && CreateModal && <CreateModal {...editModalProps} />}
                                {isNew === true && editModalShown && !CreateModal && <EditModal {...editModalProps} />}
                            </Col>
                        </Row>
                        {this._renderPagination()}
                        {fetching === fetchingState.FETCHING &&
                            <Row>
                                <Col lg={12}>
                                    <span>Загрузка...</span>
                                </Col>
                            </Row>}
                        {fetching === fetchingState.FETCHED && entities.length === 0 &&
                            <Row>
                                <Col lg={12}>
                                    <span>Пусто</span>
                                </Col>
                            </Row>}
                        {fetching === fetchingState.FAILED &&
                            <Row>
                                <Col lg={12}>
                                    <span>Ошибка</span>
                                    {error && <span>{error}</span>}
                                </Col>
                            </Row>}
                    </Panel.Body>
                </Panel>
            </Grid >
        );
    }

}

Entities.defaultProps = {
    reloadOnModalClosing: true,
    canRefresh: true,
    canCreate: true
}

export default Entities;


// WEBPACK FOOTER //
// ./src/components/common/Entities.jsx